import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=946c808c"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=946c808c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports